export default "__VITE_ASSET__BoYAEYnW__"